import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 17", "Eye", /*#__PURE__*/_jsx("path", {
  d: "M10 3.5c3.525 0 6.662 3.591 7.758 5.001C16.665 9.911 13.537 13.5 10 13.5c-3.525 0-6.662-3.591-7.758-5.001C3.335 7.089 6.463 3.5 10 3.5m0-1c-4.962 0-9 6-9 6s4.038 6 9 6 9-6 9-6-4.038-6-9-6Z"
}), /*#__PURE__*/_jsx("path", {
  d: "M10 6a2.5 2.5 0 1 1-2.5 2.5A2.503 2.503 0 0 1 10 6m0-1a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 10 5Z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconEye";
export default Icon;